import { cloneElement } from "react";
import { usePermission } from "../Hooks/CustomHooks";

export default function PermissionsGate({ children, RenderError = () => <></>, errorProps = null, scopes = [] }) {

    const permissionGranted = usePermission({ scopes });

    if (!permissionGranted && !errorProps) return <RenderError />;

    if (!permissionGranted && errorProps)
        return cloneElement(children, { ...errorProps });

    return <>{children}</>;
}